 <!-- Overlay -->
  <div class="fixed inset-0 z-50 flex justify-center items-center">

    <!-- Backdrop -->
    <button
      class="absolute inset-0 bg-black/50"
      (click)="close.emit()">
    </button>

    <!-- Modal -->
    <div class="relative p-4 w-full max-w-md max-h-full z-60">

        <!-- Body -->
        <div class="pt-4 md:pt-6">
          <ng-content></ng-content>
        </div>
    </div>
  </div>
